<template>
  <main id="main">
        <h1 class="primary--text">{{ translations.newpassword.title }}</h1>

        <loading :active.sync="visible" :can-cancel="true" :color="primary"></loading>

        <p v-if="$route.query.redirect" class="error text-center">
          {{ translations.newpassword.sent }}
        </p>

        <p v-if="error" class="error secondary button--text">
          {{ error }}
        </p>

        <form @submit.prevent="resetPassword" autocomplete="off">
          
          <div class="form-group">
            <input v-model.trim="password"
                   class="form-control"
                   :style="{'border-color': border}"
                   :placeholder="translations.newpassword.new"
                   :aria-label="translations.newpassword.new"
                   type="password"
                   required>
          </div>
          <div class="form-group">
            <input v-model.trim="password_confirmation"
                   class="form-control"
                   :style="{'border-color': border}"
                    :placeholder="translations.newpassword.newconfirmation"
                   :aria-label="translations.newpassword.newconfirmation"
                   type="password"
                   required>
          </div>
          <v-btn type="submit" class="btn btn-info btn-block secondary button--text">
            {{ translations.newpassword.change }}
          </v-btn>
        </form>

    </main>
</template>

<script>

import Loading from 'vue-loading-overlay';

export default {
  data() {
    return {
      password: "",
      password_confirmation: "",
      error: "",
      visible: false
    };
  },
  components: {
    Loading
  },
  computed: {
    translations() {
      return this.$store.getters.translations;
    },
    border() {
        return this.$vuetify.theme.themes.light.border;
    },
    primary() {
      return this.$vuetify.theme.themes.light.primary;
    }
  },
  created() {
    document.title = "Set/Reset Password - Have My Say";
    ga('set', 'title', "New Password"); // eslint-disable-line
    ga('send', 'pageview', location.hash); // eslint-disable-line
  },
  methods: {
    resetPassword() {
      this.visible = true
      this.$store
        .dispatch("resetPassword", {
          password: this.password,
          token: this.$route.params.token,
          user_id: this.$route.params.id
        })
        .then(() => {
          this.visible = false
          this.$router.replace(this.$route.query.redirect || "/");
        })
        .catch(() => {
          this.visible = false
          if(this.$store.state.apiResponse === "expiry") {
            this.error = this.translations.apiresponse.expiry;
          } else if (this.$store.state.apiResponse === "incorrect") {
            this.error = this.translations.apiresponse.incorrect;
          } else {
            this.error = this.translations.apiresponse.unable;
          }
        });
    }
  }
};
</script>

<style scoped lang="scss">

  a, button {
      &:focus {
          outline: dashed 3px black;
      }
  }

  .error {
      padding: 10px;
    }
    .form-control {
      padding: 10px;
      margin-bottom: 20px;
      min-height: 40px;
      border: 3px solid;
      border-radius: 5px;

      @media(min-width: 1000px) {
        min-width: 80%;
      }
    }
    button {
      padding: 10px 30px;
      border: none;
      border-radius: 5px;
      font-weight: bold;

      @media(min-width: 1000px) {
        min-width: 80%;
      }
    }
    .password__link {
      display: inline-block;
      margin-top: 30px;
    }

    @media(min-width: 1000px) {
        .form-control {
            font-size: 20px;
        }
        ::-webkit-input-placeholder { /* WebKit, Blink, Edge */
            color:   black;
        }
        :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
            color:   black;
        }
        ::-moz-placeholder { /* Mozilla Firefox 19+ */
            color:   black;
        }
        :-ms-input-placeholder { /* Internet Explorer 10-11 */
            color:   black;
        }
    }
</style>